import { useCallback, useMemo, useState } from 'react';

interface UseShowMoreSeatNamesParams {
  items: string[];
  visibleCount?: number;
}

export const useShowMoreSeatNames = ({ items, visibleCount = 4 }: UseShowMoreSeatNamesParams) => {
  const [expanded, setExpanded] = useState(false);

  const hasMoreThanVisible = items.length > visibleCount;
  const hiddenCount = Math.max(0, items.length - visibleCount);

  const displayedItems = useMemo(
    () => (expanded ? items : items.slice(0, visibleCount)),
    [expanded, items, visibleCount]
  );

  const displayedText = useMemo(() => displayedItems.join(', '), [displayedItems]);

  const handleSetExpanded = useCallback(() => {
    setExpanded(prev => !prev);
  }, []);

  return {
    expanded,
    hasMoreThanVisible,
    hiddenCount,
    displayedText,
    handleSetExpanded,
  };
};
